export type FetchAttributeValue = string | number | boolean;

export type FetchElementName =
  | "fetch"
  | "entity"
  | "attribute"
  | "all-attributes"
  | "order"
  | "filter"
  | "condition"
  | "value"
  | "link-entity";

export type FetchAttributes = Record<string, FetchAttributeValue>;

export interface FetchElement {
  name: FetchElementName;
  attributes: FetchAttributes;
  children: FetchElement[];
  text?: string;
}

export interface ElementRule {
  requiredAttributes: string[];
  allowedAttributes: string[];
  allowedChildren: FetchElementName[];
}

export const ELEMENT_RULES: Record<FetchElementName, ElementRule> = {
  fetch: {
    requiredAttributes: [],
    allowedAttributes: [
      "version",
      "top",
      "count",
      "page",
      "paging-cookie",
      "aggregatelimit",
      "useraworderby",
      "distinct",
      "no-lock",
      "mapping",
      "output-format",
      "returntotalrecordcount",
      "aggregate",
      "min-active-row-version",
      "datasource",
      "latematerialize"
    ],
    allowedChildren: ["entity"]
  },
  entity: {
    requiredAttributes: ["name"],
    allowedAttributes: ["name", "enableprefiltering", "prefilterparametername", "hint-options"],
    allowedChildren: ["attribute", "all-attributes", "order", "filter", "link-entity"]
  },
  attribute: {
    requiredAttributes: ["name"],
    allowedAttributes: ["name", "alias", "aggregate", "groupby", "dategrouping", "usertimezone", "addedby"],
    allowedChildren: []
  },
  "all-attributes": {
    requiredAttributes: [],
    allowedAttributes: [],
    allowedChildren: []
  },
  order: {
    requiredAttributes: ["attribute"],
    allowedAttributes: ["attribute", "alias", "descending"],
    allowedChildren: []
  },
  filter: {
    requiredAttributes: [],
    allowedAttributes: [
      "type",
      "isquickfindfields",
      "overridequickfindrecordlimitenabled",
      "overridequickfindrecordlimitdisabled",
      "hint"
    ],
    allowedChildren: ["condition", "filter", "link-entity"]
  },
  condition: {
    requiredAttributes: ["attribute", "operator"],
    allowedAttributes: [
      "attribute",
      "operator",
      "value",
      "values",
      "valueof",
      "entityname",
      "alias",
      "uiname",
      "uitype",
      "aggregate"
    ],
    allowedChildren: ["value"]
  },
  value: {
    requiredAttributes: [],
    allowedAttributes: [],
    allowedChildren: []
  },
  "link-entity": {
    requiredAttributes: ["name", "from", "to"],
    allowedAttributes: [
      "name",
      "from",
      "to",
      "alias",
      "link-type",
      "intersect",
      "visible",
      "enableprefiltering",
      "prefilterparametername",
      "entityname"
    ],
    allowedChildren: ["attribute", "all-attributes", "order", "filter", "link-entity"]
  }
};

export function element(name: FetchElementName, attributes: FetchAttributes = {}, children: FetchElement[] = [], text?: string): FetchElement {
  return { name, attributes, children, text };
}
